<script setup>
import {defineProps, defineEmits} from "vue";
import LinhaDeAdiantamento from "./LinhaDeAdiantamento/LinhaDeAdiantamento.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
]);

const emits = defineEmits([
    "update:alteraAdiantamento"
]);

//==================================================================//
//====================== Altera Adiantamento =======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    emits('update:alteraAdiantamento',update);

};

</script>

<template>

    <div class="c-table__body">

        <LinhaDeAdiantamento v-for="adiantamento in props?.parcela?.lista"
            :key="adiantamento?.id"
            :dado="props?.dado"
            :parcela="props?.parcela"
            :adiantamento="adiantamento"
            @update:alteraAdiantamento="alteraAdiantamento"
        ></LinhaDeAdiantamento>

    </div>

</template>

<style scoped>

.c-table__body{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>